import _ from "lodash";

const PrimaryPlanTxnAccessSvc = function ($http, $q, $window) {
    const cacheUrl = __baseApiUrl__ + "/participant-web-services/rest/primaryPlan/hasTxnAccess/";
    const cache = {};
    const pending = {};

    const hasAccessCodes = function (txnCodes) {
        return _.every(txnCodes.split(","), function (code) {
            return _.has(cache, _.trim(code));
        });
    };

    this.query = function (params) {
        if (pending[params.txnCode]) {
            return pending[params.txnCode];
        }
        const url = cacheUrl + params.txnCode;
        const deferred = $q.defer();
        pending[params.txnCode] = deferred.promise;
        if (hasAccessCodes(params.txnCode)) {
            deferred.resolve(cache);
            delete pending[params.txnCode];
        } else {
            $http({
                url: url,
                method: "GET",
                isArray: false
            })
                .then(function (resp) {
                    _.extend(
                        cache,
                        _.mapValues(resp.data, function (value) {
                            return value === "true" || value === true;
                        })
                    );
                    deferred.resolve(cache);
                    delete pending[params.txnCode];
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    delete pending[params.txnCode];
                });
        }
        return deferred.promise;
    };

    return {
        query: this.query
    };
};

PrimaryPlanTxnAccessSvc.$inject = ["$http", "$q", "$window"];
export default PrimaryPlanTxnAccessSvc;
